document.addEventListener('DOMContentLoaded', () => {
	const buildingSelect = document.getElementById('buildings_list');
	if (buildingSelect) {
		new TomSelect(buildingSelect);
	}
});
